<template>
  <div class="status-history-section bg-white p-3 my-2 rounded" :class="{ 'status-history-section-bordered, shadow-sm': bordered }">
    <slot></slot>
    <div v-if="historyItems.length === 0" class="text-center py-4">
      <custom-result-not-found
        class="mt-4 row pt-3"
        text="No hay Información Disponible."
      />
    </div>

    <div v-else>
      <time-line>
        <time-line-item
          v-for="(item, index) in historyItems"
          :key="`history-${index}`"
          :color="getStatusBgClass(item.statusId)"
        >
          <template #date>
            <div class="date-container">
              <div>Fecha</div>
              <div>{{ item.date | date }}</div>
              <div><small>{{ item.date | hour }}</small></div>
            </div>
          </template>
          <div class="row align-items-center">
            <div class="col-md-6 col-12 mb-2 mb-md-0">
              <div class="d-flex align-items-center">
                <span 
                  class="status-dot mr-2"
                  :class="getStatusBgClass(item.statusId)"
                ></span>
                <span class="font-weight-bold font-14 color-dark">
                  {{ item.statusName }}
                </span>
              </div>
            </div>
            
            <div class="col-md-6 col-12">
              <span class="color-gray font-12 d-block">Nombre del Usuario:</span>
              <span class="color-dark font-14">
                {{ item.userName }}
              </span>
            </div>
          </div>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import { resolveStatusColor } from '@/views/eden/shared/components/utils.js';

export default {
  name: 'StatusHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
  },
  props: {
    historyItems: {
      type: Array,
      default: () => [],
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    getStatusBgClass(statusId) {
      return resolveStatusColor(statusId);
    },
  },
};
</script>

<style scoped>
.status-history-section {
  max-height: 600px;
  overflow-y: auto;
}

.status-history-section-bordered {
  border: 1px solid #e8e8e8;
}

.timeline-content-card {
  border-left: 3px solid #FF7058;
}

.status-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.bg-blue-light {
  background-color: #d4e6f9;
  color: #1a5490;
}

.date-container {
  text-align: end;
}
</style>
